<dialog #dlg class="cx-dlg" aria-labelledby="cxHowT" (click)="OnDialogClick($event)">
  <div class="cx-dlg__panel">
    <h2 id="cxHowT">About Career Explorer</h2>
    <p class="cx-dlg__lede">Career Explorer reads your CV and shows the careers it points toward, built with Julius, AGU’s career-mapping partner. Here is how it works.</p>
    <ol>
      <li><b>We read your full CV.</b> Every position, degree, grant and skill becomes a tag. Tags you state outright are confirmed straight away.</li>
      <li><b>You check what we inferred.</b> Some tags are implied rather than stated. Each one quotes the line it came from, so you can accept or decline it in seconds.</li>
      <li><b>We match you to occupations, not postings.</b> Each occupation is built from thousands of current job ads. Your score is the weighted share of what it asks for that your record shows.</li>
      <li><b>Then you look at real openings.</b> From any role, search the Job Finder or the wider market. Your profile is never sent to employers.</li>
    </ol>
    <div class="ft">
      <span class="cx-pow">Powered by <b>Julius</b></span>
      <button class="cx-btn pri" type="button" (click)="Close()">Got it</button>
    </div>
  </div>
</dialog>
